module.exports = __webpack_public_path__ + "images/icons/logos/global-white-89dc7f73.svg";